module.exports = __webpack_public_path__ + "static/img/home_page bottom_mobile.d350a805.jpg";